import Select from 'components/Formik/Select';
import Text from 'components/Formik/Text';
import { useEffect } from 'react';

const Location = ({ formik, initialValues, data }) => {
	const {
		country,
		city,
		postal_code,
		us_states,
		australian_states,
		canadian_states,
		newzealand_states,
	} = data;
	initialValues.Country = '';
	initialValues.City = '';
	initialValues.State = '';
	initialValues.PostalCode = '';
	useEffect(() => {
		formik.values.State = '';
		formik.values.City = '';
		formik.values.PostalCode = '';
	}, [formik.values.Country]);

	return (
		<>
			{data?.Country==="AU"?<Select
				label={country.label}
				name='Country'
				placeholder={country.placeholder}
				options={[
					{
						value: 'Australia',
						label: 'Australia',
					}]}
			/>:<Select
			label={country.label}
			name='Country'
			placeholder={country.placeholder}
			options={country.options}
			/>}
			<Text label={city} name='City' type='text' />
			<Text label={postal_code} name='PostalCode' type='text' />
			{formik.values.Country === 'United States' && (
				<>
					<Select
						label={us_states.label}
						placeholder={us_states.placeholder}
						name='State'
						options={us_states.options}
					/>
				</>
			)}
			{formik.values.Country === 'Australia' && (
				<>
					<Select
						label={australian_states.label}
						placeholder={australian_states.placeholder}
						name='State'
						options={australian_states.options}
					/>
				</>
			)}
			{formik.values.Country === 'Canada' && (
				<>
					<Select
						label={canadian_states.label}
						placeholder={canadian_states.placeholder}
						name='State'
						options={canadian_states.options}
					/>
				</>
			)}
			{formik.values.Country === 'New Zealand' && (
				<>
					<Select
						label={newzealand_states.label}
						placeholder={newzealand_states.placeholder}
						name='State'
						options={newzealand_states.options}
					/>
				</>
			)}
		</>
	);
};

export default Location;
